var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "newMiniFilterPreview" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: {
                followCursor: true,
                placement: "bottom-end",
                delay: [500, 0],
              },
              expression:
                "{ followCursor: true, placement: 'bottom-end', delay: [500, 0] }",
            },
          ],
          staticClass: "title",
          attrs: { content: _vm.getTitle() },
        },
        [
          _c("span", [
            _vm._v("\n            " + _vm._s(_vm.getTitle()) + "\n        "),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "material-icons",
              staticStyle: { "font-size": "16px", cursor: "pointer" },
              on: { click: _vm.deleteFilter },
            },
            [_vm._v(" close ")]
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.IGNORE_TYPES.includes(_vm.filter.rule)
        ? [
            _vm.selectedFilter.type === "contact-property-selector"
              ? _c(
                  "div",
                  { staticClass: "dropdown-picker" },
                  [
                    _c("ContactPropertySelectorInline", {
                      attrs: { propertyId: _vm.filter.input },
                      model: {
                        value: _vm.filter.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "value", $$v)
                        },
                        expression: "filter.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm.selectedFilter.type === "country-selector"
              ? _c(
                  "div",
                  { staticClass: "dropdown-picker" },
                  [
                    _c("CountrySelectorInline", {
                      model: {
                        value: _vm.filter.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "value", $$v)
                        },
                        expression: "filter.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm.selectedFilter.type === "city-selector"
              ? _c(
                  "div",
                  { staticClass: "dropdown-picker" },
                  [
                    _c("CitySelectorInline", {
                      model: {
                        value: _vm.filter.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "value", $$v)
                        },
                        expression: "filter.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm.selectedFilter.type === "browser-selector"
              ? _c(
                  "div",
                  { staticClass: "dropdown-picker" },
                  [
                    _c("BrowserSelectorInline", {
                      model: {
                        value: _vm.filter.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "value", $$v)
                        },
                        expression: "filter.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm.selectedFilter.type === "os-selector"
              ? _c(
                  "div",
                  { staticClass: "dropdown-picker" },
                  [
                    _c("OSSelectorInline", {
                      model: {
                        value: _vm.filter.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "value", $$v)
                        },
                        expression: "filter.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm.selectedFilter.type === "platform-selector"
              ? _c(
                  "div",
                  { staticClass: "dropdown-picker" },
                  [
                    _c("PlatformSelectorInline", {
                      attrs: { multiple: _vm.selectedFilter.multiple },
                      model: {
                        value: _vm.filter.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "value", $$v)
                        },
                        expression: "filter.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm.selectedFilter.type === "select"
              ? _c(
                  "div",
                  { staticClass: "dropdown-picker" },
                  [
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          mode: _vm.selectedFilter.multiple
                            ? "multiple"
                            : "default",
                        },
                        model: {
                          value: _vm.filter.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "value", $$v)
                          },
                          expression: "filter.value",
                        },
                      },
                      _vm._l(_vm.selectedFilter.options, function (option) {
                        return _c(
                          "a-select-option",
                          {
                            key: option.key,
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                            attrs: { value: option.key },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(option.value) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm.selectedFilter.type === "input"
              ? _c(
                  "div",
                  {
                    staticClass: "input-picker",
                    staticStyle: { "margin-top": "3px" },
                  },
                  [
                    _c("a-input", {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.filter.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "value", $$v)
                        },
                        expression: "filter.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm.selectedFilter.type === "date-select"
              ? _c(
                  "div",
                  {
                    staticClass: "date-select-picker",
                    staticStyle: { "margin-top": "3px" },
                  },
                  [
                    _c("DateSelectorInline", {
                      model: {
                        value: _vm.filter.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "value", $$v)
                        },
                        expression: "filter.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }